<template>
  <div class="dft-title_text" :style="title_text_Style">
    <el-button type="text" v-if="checkMore" class="resetBtn checkMore">查看更多</el-button>
    <div class="dft-title" :style="title_Style">
      {{ title }}
    </div>
    <div class="dft-subtitle" :style="subtitle_Style">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata',newVal)
          })
        }
      },
      deep: true
    }
  },
  computed: {
    // 数据
    title () {
      return this.compData[0]?.value
    },
    subtitle () {
      return this.compData[1]?.value
    },
    // 样式
    title_text_Style () {
      return {
        [this.compData[2]?.key]: this.compData[2]?.value,
        [this.compData[9]?.key]: this.compData[9]?.value,
        [this.compData[10]?.key]: this.compData[10]?.value == '1' ? '1px solid #e7e7e7' : 'none'
      }
    },
    title_Style () {
      return {
        [this.compData[3]?.key]: this.compData[3]?.value,
        [this.compData[5]?.key]: this.compData[5]?.value,
        [this.compData[7]?.key]: this.compData[7]?.value
      }
    },
    subtitle_Style () {
      return {
        [this.compData[4]?.key]: this.compData[4]?.value,
        [this.compData[6]?.key]: this.compData[6]?.value,
        [this.compData[8]?.key]: this.compData[8]?.value
      }
    },
    checkMore () {
      return this.compData[11]?.value == '1'
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-title_text{
  width: 100%;
  box-sizing: border-box;
  padding: 8px 14px;
  .checkMore{
    float: right;
    height: 20px;
    padding: 0 8px;
  }
  .dft-title{
    font-family: PingFang SC, PingFang SC;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    color: #323232;
  }
  .dft-subtitle{
    font-size: 14px;
    font-weight: 400;
    color: #8c8c8c;
  }
}
.resetBtn{
  font-size: 13px;
  color: #356fd4;
}
</style>
